import { render } from "./repair-item-tree.vue?vue&type=template&id=2f80ef61&scoped=true&ts=true"
import script from "./repair-item-tree.vue?vue&type=script&lang=ts"
export * from "./repair-item-tree.vue?vue&type=script&lang=ts"

import "./repair-item-tree.vue?vue&type=style&index=0&id=2f80ef61&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f80ef61"]])

export default __exports__